module.exports = __webpack_public_path__ + "media/images/icons/twotone/money-collect-fbfd160b4ab5c598b261dc1c40b4a36c.svg";